import gql from "graphql-tag";

const CELL_FIELDS = `
    id
    cell_type
    background_color
    text_color
    background_color_filter
    background_color_filter_checked
    text_color_filter
    text_color_filter_selected
    border_color_selected_filter
    font_size_filter
    bolder_radius_filter
    show_all_tab
    background_color_card
    text_color_name
    text_color_subtitle
    border_color_card
    font_size_name
    font_size_subtitle
    image_size
    list_max_height_vh
    background_color_pop_up
    text_color_pop_up
    text_color_pop_up_title
    color_button_close
    font_size_popup
    font_family
    color_theme
    background_image_uri
    background_fit
    items {
        id
        cell_id
        category
        name
        subtitle
        description
        image_uri
        sort_order
    }
`;

export default {
    get: gql`
    query Products2Cell($id: ID!) {
        products2Cell(id: $id) {
            ${CELL_FIELDS}
        }
    }`,

    update: gql`
    mutation UpdateProducts2Cell ($input: UpdateProducts2CellInput!) {
        updateProducts2Cell (input: $input) {
            ${CELL_FIELDS}
        }
    }`,

    addItem: gql`
    mutation AddProducts2Item($input: AddProducts2ItemInput!) {
        addProducts2Item(input: $input) {
            id
        }
    }`,

    updateItem: gql`
    mutation UpdateProducts2Item($input: UpdateProducts2ItemInput!) {
        updateProducts2Item(input: $input) {
            id
        }
    }`,

    deleteItem: gql`
    mutation DeleteProducts2Item($id: ID!) {
        deleteProducts2Item(id: $id)
    }`,
};
